export const PATIENT_FILE_TAGS = {
    PROFILE_IMAGE: 'Profile-image',
    PARTNER_PROFILE_IMAGE: 'Partner-profile-image',
    DOCUMENT: 'Document',
    PRESCRIPTION: 'Prescription',
    REPORT: 'Report',
    INVOICE: 'Invoice',
    OTHER: 'Other',
}